import { FC, useMemo, useState } from "react";
import { MDBRow } from "mdb-react-ui-kit";
import { useIsSM } from "@/utils/hooks/useWindowSizes";
import { ISectionTitle } from "../../../models/common/common";
import styles from "../../../styles/home/Home.ItalianTour.module.scss";
import ItalianTourLayout from "./ItalianTourLayout";
import {
    italianTourSingleSectionSubTitle,
    italianTourSingleSectionTitle,
} from "../../../utils/mockData/homeMocks";
import { ToursEntity } from "../../../models/home";
import CardTour from "../cards/cardTour/CardTour";
import ItalianTourCarousel from "./ItalianTourCarousel";

const ItalianTourSingleType: FC<{
    content: ToursEntity[];
}> = ({ content }) => {
    const sectionTitleData: ISectionTitle = {
        title: italianTourSingleSectionTitle,
        subTitle: italianTourSingleSectionSubTitle,
        alignment:
            "justify-content-start text-align-left justify-content-sm-center text-sm-center",
        fluid: true,
        classNameSubTitle: styles.italianTourParagraph,
        classNameTitle: styles.italianTourTitle,
        classNameTitleContainer: styles.italianTourTitleContainer,
        classNameContainer: "py-3",
    };

    const isSM = useIsSM();

    const visibleCards = useMemo(() => {
        return (
            content.map(tour => {
                /* eslint-disable no-underscore-dangle */
                return (
                    <CardTour
                        className={styles.italianTourCard}
                        key={tour._id}
                        content={tour}
                        height={isSM ? "45%" : "55%"}
                        isSmall
                    />
                );
                /* eslint-enable no-underscore-dangle */
            }) ?? []
        );
    }, [content]);

    const [resetIndex, setResetIndex] = useState<boolean>(false);

    return (
        <ItalianTourLayout sectionTitleData={sectionTitleData}>
            <MDBRow className="py-2 mx-2 d-flex  justify-content-center">
                <ItalianTourCarousel
                    setResetIndex={setResetIndex}
                    resetIndex={resetIndex}
                >
                    {visibleCards}
                </ItalianTourCarousel>
            </MDBRow>
        </ItalianTourLayout>
    );
};

export default ItalianTourSingleType;
